export default __webpack_public_path__ + "static/media/kitchen5-beforeD-2048w.be3d57ae.webp";